import { render, staticRenderFns } from "./ItemsIncomeReport.vue?vue&type=template&id=5dcd2c4a"
import script from "./ItemsIncomeReport.vue?vue&type=script&lang=js"
export * from "./ItemsIncomeReport.vue?vue&type=script&lang=js"
import style1 from "./ItemsIncomeReport.vue?vue&type=style&index=1&id=5dcd2c4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports